// imports
import CRMultiSelect from 'minsky-kit/js/components/CRMultiSelect';
import CTDrupalView from './CTDrupalView';
import InstanceManager from 'minsky-kit/js/managers/InstanceManager';
import FaqAccordion from './FaqAccordion';

// private statics

// class definition
export default class FaqOverview extends CTDrupalView {
    // constructor
    constructor (args = {}, objectName = 'FaqOverview') {
        args.debug = args.debug || true;

        // super
        super(args, objectName);

        // add listeners
        this.on('view_refresh', onViewRefresh);
        this._im = new InstanceManager(); // https://bitbucket.org/Minsky_WebAgency/minsky-kit/src/master/documentation/InstanceManager.md

        initView.call(this);
    }

    // methods
    refresh (...args) {
        super.refresh(...args);

        // destroy instances
        this._im.destroy([
            'faq-accordion',
        ]);
    }

    show (...args) {
        super.show(...args);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils
function initView () {
    this._$submit = this.$el.querySelector('.form-submit');
    this.$filterSelectFaqType = this.$el.querySelector('.views-exposed-form .form-item-faq-type select');
    this.colors = JSON.parse( this.$el.querySelector('.view-exposed').getAttribute('data-colors'));

    // hide submit button
    this._$submit.parentNode.classList.add('noRender');

    // destroy filter instances
    if (this.filterFaqTypes) {
        this.filterFaqTypes.destroy();
    }

    // create filter instances
    if (this.$filterSelectFaqType) {
        this.filterFaqTypes = new CRMultiSelect({ $el: this.$filterSelectFaqType });

        this.filterFaqTypes.$el.classList.add('cr-multi-select--primary');
        
        // add colors to filters
        this.$filterSelectFaqTypeOptions = this.$el.querySelectorAll('.views-exposed-form .cr-multi-select--primary .form__item input');
        if (this.colors) {
            const colors = {};
            this.colors.forEach(c => {
                colors[c.id] = c.color;
            });

            this.$filterSelectFaqTypeOptions.forEach(option => {
                const optionValue = option.getAttribute('value');

                if (optionValue) {
                    option.nextElementSibling.style.backgroundColor = colors[optionValue];
                }
            });
        }

        this.filterFaqTypes.on('change', this.blm.addOnce('onFilterChange', onFilterChange));
    }

    // init accordion
    this._im.initAddComponent('faq-accordion', FaqAccordion, '.view--faq-overview .views-row .faq-overview__accordion');

}

// Event handlers
function onViewRefresh () {
    initView.call(this);
}

function onFilterChange () {
    this._$submit.click();
}
